import { useState } from 'react';
import { BadgeCheck, Banknote, type LucideIcon } from 'lucide-react';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { usePermissions } from '@/features/auth/hooks/usePermissions';
import {
  DONATION_BATCH_ORIGIN,
  type DonationBatchOrigin,
} from '../constants/marketPromotion.constants';
import type { DonationBatch } from '../types/marketPromotionP2.types';
import type { DonationBatchPanel } from './useDonationBatchFilters';

const BATCH_ACTION_LOOK: Record<DonationBatchPanel, { label: string; icon: LucideIcon }> = {
  publish: { label: 'Confirm', icon: BadgeCheck },
  accounts: { label: 'Disburse', icon: Banknote },
};

export function getDonationBatchPanel(from: DonationBatchOrigin): DonationBatchPanel {
  return from === DONATION_BATCH_ORIGIN.accounts ? 'accounts' : 'publish';
}

export function useDonationBatchAction(panel: DonationBatchPanel) {
  const { can } = usePermissions();
  const [actingBatch, setActingBatch] = useState<DonationBatch | null>(null);

  function canAct(batch: DonationBatch): boolean {
    if (batch.isDisburse) return false;
    if (panel === 'publish') {
      return can(MARKET_PROMOTION_PERMISSIONS.PUBLISH_PANEL_CONFIRM) && batch.isConfirm !== true;
    }
    return can(MARKET_PROMOTION_PERMISSIONS.ACCOUNTS_ADJUST_DISBURSE) && batch.isConfirm === true;
  }

  return {
    action: { ...BATCH_ACTION_LOOK[panel], onClick: setActingBatch, when: canAct },
    actingBatch,
    closeAction: () => setActingBatch(null),
  };
}
